import { TelevisionClassicOffIcon } from './TelevisionClassicOffIcon';

/**
 * author: Austin Andrews
 * id C8E89001-2566-4676-B12B-7AAFAFCA0276
 * name television-classic-off
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-classic-off.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const TvClassicOffIcon = TelevisionClassicOffIcon;
export default TvClassicOffIcon